module.exports = __webpack_public_path__ + "static/media/nav-icon-hiring-active.a7cd5ec1.svg";